export const updateThemeColor = (theme: 'light' | 'dark') => {
  // Update theme-color meta tag for status bar
  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  const msNavButtonMeta = document.querySelector('meta[name="msapplication-navbutton-color"]');
  const msTileColorMeta = document.querySelector('meta[name="msapplication-TileColor"]');
  
  // Get colors from CSS variables to match seamlessly with gradient
  const rootStyles = getComputedStyle(document.documentElement);
  const statusBarColor = rootStyles.getPropertyValue('--status-bar-color').trim();
  
  // Fallback colors if CSS variables aren't available
  const lightColor = statusBarColor || '#e2e8f0'; // Light theme gradient start color
  const darkColor = theme === 'dark' ? '#0f172a' : lightColor;  // Dark theme gradient start color
  
  const color = theme === 'dark' ? darkColor : lightColor;
  
  if (themeColorMeta) {
    themeColorMeta.setAttribute('content', color);
  }
  
  if (msNavButtonMeta) {
    msNavButtonMeta.setAttribute('content', color);
  }
  
  if (msTileColorMeta) {
    msTileColorMeta.setAttribute('content', color);
  }
  
  // Also update the status bar style for iOS
  const statusBarMeta = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
  if (statusBarMeta) {
    // Use black-translucent to allow our background to show through
    statusBarMeta.setAttribute('content', 'black-translucent');
  }
};
